module.exports = __webpack_public_path__ + "static/horecabeveiliging-5a8b9f645c50bdc4d50cc378804bd86f.png";